export const GET_DEVICE_ACTIVITIES = 'GET_DEVICE_ACTIVITIES';
export const GET_DEVICE_ACTIVITIES_SUCCESS = 'GET_DEVICE_ACTIVITIES_SUCCES';
export const GET_DEVICE_ACTIVITIES_ERROR = 'GET_DEVICE_ACTIVITIES_ERROR';

export const GET_USER_DEVICE_ACTIVITIES = 'GET_USER_DEVICE_ACTIVITIES';
export const GET_USER_DEVICE_ACTIVITIES_SUCCESS = 'GET_USER_DEVICE_ACTIVITIES_SUCCES';
export const GET_USER_DEVICE_ACTIVITIES_ERROR = 'GET_USER_DEVICE_ACTIVITIES_ERROR';
